import type { AssetType } from "schemas/generated/asset";

import * as React from "react";

import ComponentTemplateDragOverlay from "@v1/components/ComponentTemplateDragOverlay";
import { image as imageComponentTemplate } from "replo-templates/image";
import { videoPlayer as videoComponentTemplate } from "replo-templates/videoPlayer";
import { exhaustiveSwitch } from "replo-utils/lib/misc";

const AssetCardDragOverlay: React.FC<
  React.PropsWithChildren<{
    asset: {
      id: string;
      type: AssetType;
      url: string;
      altText: string;
    };
    shouldAllowDrag: boolean;
  }>
> = ({ asset, children, shouldAllowDrag }) => {
  if (!shouldAllowDrag) {
    return children;
  }

  const { id, type, url } = asset;

  const template = exhaustiveSwitch(asset)({
    image: {
      ...imageComponentTemplate,
      template: {
        ...imageComponentTemplate.template!,
        props: {
          ...imageComponentTemplate.template!.props,
          src: url,
          style: {
            ...imageComponentTemplate.template!.props.style,
            __imageAltText: asset.altText,
          },
        },
      },
    },
    video: {
      ...videoComponentTemplate,
      template: {
        ...videoComponentTemplate.template!,
        props: { ...videoComponentTemplate.template!.props, url },
      },
    },
    font: () => {
      // eslint-disable-next-line replo/no-raw-error-throw
      throw new Error(`Unknown asset type: ${type}`);
    },
  });

  return (
    <div className="relative">
      <ComponentTemplateDragOverlay
        showOutlineOnHover={false}
        identifier={id}
        template={template}
        scope="left-bar"
        dragType="newComponent"
      />
      {children}
    </div>
  );
};

export default AssetCardDragOverlay;
